import React from "react";
import { Navigate } from "react-router-dom";
import { LoginWidget } from "@madie/madie-auth";
import {
  useDocumentTitle,
  OktaConfig,
  ServiceConfig,
  useServiceConfig,
} from "@madie/madie-util";
import { useOktaAuth } from "@okta/okta-react";
import { loginLogger } from "../../custom-hooks/customLog";

function Login({ config }: { config: OktaConfig }) {
  useDocumentTitle("MADiE Login");
  const { oktaAuth, authState } = useOktaAuth();
  const serviceConfig: ServiceConfig = useServiceConfig();

  const loginConfig = {
    props: {
      config: config,
      onSuccess: (tokens) => {
        oktaAuth.handleLoginRedirect(tokens);
        if (oktaAuth.token != null && oktaAuth.token.getUserInfo() != null) {
          oktaAuth.token
            .getUserInfo()
            .then((info) => {
              loginLogger(info, serviceConfig);
            })
            .catch((error) => {
              console.error("Error writing Login info", error);
            });
        }
      },
      onError: (err) => {
        /* Placeholder to handle error returned from login widget  */
      },
    },
  };

  if (!authState) return null;
  return authState.isAuthenticated ? (
    <Navigate to="/measures" />
  ) : (
    <>
      <LoginWidget {...loginConfig} />
    </>
  );
}
export default Login;
